// Spec 078 US5 — a cena pela rota PÚBLICA (`/display/:token`), sem sessão. Polling de 4 s;
// sem retry (o 404 é a resposta definitiva "link desativado", não um erro transitório).
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { DISPLAY_POLL_MS } from "@opus-dt/shared-types";
import { api, isApiClientError } from "@/lib/api-client";
import type { LineSceneResponse } from "@/types/scene.types";

export const displaySceneKey = (token: string) => ["display-scene", token] as const;

export interface UseDisplayScene {
  query: UseQueryResult<LineSceneResponse>;
  linkInactive: boolean;
}

export function useDisplayScene(token: string | null): UseDisplayScene {
  const query = useQuery({
    queryKey: displaySceneKey(token ?? ""),
    queryFn: () => api.get<LineSceneResponse>(`/api/v1/display/${token}/scene`),
    enabled: Boolean(token),
    refetchInterval: DISPLAY_POLL_MS,
    refetchIntervalInBackground: true,
    retry: false,
    placeholderData: (prev) => prev,
  });
  const err = query.error;
  const linkInactive = isApiClientError(err) && (err.status === 404 || err.status === 400);
  return { query, linkInactive };
}
